import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getFormatsByCountry } from '@client/services/country.data.service'

function getCountryFullName(country) {
  switch (country) {
    case 'br':
      return 'Brazil'
    case 'uk':
      return 'United Kingdom'
    case 'mx':
      return 'Mexico'
    case 'us':
    default:
      return 'United States'
  }
}

export default function useInternationalization() {
  const { country, language } = useSelector(store => store.application)
  const [formats, setFormats] = useState({ currency: {} })
  const countryFullName = getCountryFullName(country)

  useEffect(() => {
    ;(async () => {
      const { data } = await getFormatsByCountry(country)
      setFormats(data)
    })()
  }, [])

  return { country, language, formats, countryFullName }
}
